<template>
  <form>
    <select-field
      v-model="innerReportType"
      name="レポート種類"
      label="レポート種類"
      rules="required"
      :class="`${(innerReportType == null) ? 'no-category-selected' : ''}`"
      :options="optionReportType"
      :disabled="isEdit"
      full-width
      return-object
    />
    <div v-if="innerReportType != null" class="mt-4">
      <input-field
        v-model="innerReportName"
        name="レポート名"
        label="レポート名"
        rules="required|max:100"
        full-width
      />

      <select-field
        v-model="innerOrder"
        name="オーダー"
        label="オーダー"
        rules="required"
        class="mt-4"
        :options="optionOrder"
        :max-result-shown="10"
        :disabled="isEdit"
        multiple
        full-width
      />

      <select-field
        v-model="innerLineItem"
        name="ラインアイテム"
        label="ラインアイテム"
        rules=""
        class="mt-4"
        :options="optionLineItem"
        :max-result-shown="10"
        :disabled="isEdit"
        multiple
        full-width
      />

      <div v-if="innerReportType.value === 7">
        <select-field
          v-model="innerSegment"
          name="セグメント"
          label="セグメント"
          rules=""
          class="mt-4"
          :options="optionSegment"
          :disabled="isEdit"
          full-width
        />
      </div>
      <div v-else-if="innerReportType.value === 9">
        <select-field
          v-model="innerSegment"
          name="セグメント"
          label="セグメント"
          rules="required"
          class="mt-4"
          :options="optionSegment"
          :disabled="isEdit"
          full-width
        />
      </div>

      <div v-if="innerReportType.value === 7 || innerReportType.value === 12" class="vx-row">
        <div class="vx-col justify-center items-center w-1/2">
          <select-field
            v-model="innerCategory"
            name="カテゴリー"
            label="カテゴリー"
            class="mt-4"
            :options="optionCategory"
            :disabled="isEdit"
            full-width
          />
        </div>
        <div class="vx-col justify-center items-center w-1/2">
          <select-field
            v-model="innerCategories"
            name="カテゴリー名"
            label=" "
            class="mt-4"
            :options="optionCategories"
            :disabled="innerCategory === null || isEdit"
            :max-result-shown="10"
            full-width
            multiple
          />
        </div>
      </div>
      <select-field
        v-if="innerReportType.value === 12"
        v-model="innerReachType"
        name="リーチ種別"
        label="リーチ種別"
        rules="required"
        class="mt-4"
        :options="optionReachTypeNonVideo"
        :disabled="isEdit"
        full-width
      />
      <select-field
      v-else
        v-model="innerReachType"
        name="リーチ種別"
        label="リーチ種別"
        rules="required"
        class="mt-4"
        :options="optionReachType"
        :disabled="isEdit"
        full-width
      />
      <div class="vx-row mt-4">
        <div class="vx-col justify-center items-center w-1/2">
          <DateField
            v-model="innerBeforeDate"
            name="広告配信開始日"
            label="広告配信期間"
            rules="required"
            :min-date="minDate"
            :max-date="maxDate"
            full-width
          />
        </div>
        <div class="vx-col justify-center items-center w-1/2">
          <DateField
            v-model="innerAfterDate"
            name="広告配信終了日"
            rules="required"
            :min-date="minDate"
            :max-date="maxDate"
            full-width
          />
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { mapState } from 'vuex'
import InputField from '@/components/fields/InputField'
import SelectField from '@/components/fields/SelectField'
import DateField from '@/components/fields/DateField'
import AMC_REPORT_TYPE from '@/constants/AmcReportType'

export default {
  name: 'AmcBrandReportForm',
  components: {
    InputField,
    SelectField,
    DateField
  },
  props: {
    reportType: {
      type: Object,
      default: null
    },
    reportName: {
      type: String,
      default: null
    },
    order: {
      type: Array
    },
    lineItem: {
      type: Array
    },
    segment: {
      type: String,
      default: null
    },
    category: {
      type: String,
      default: null
    },
    categories: {
      type: Array
    },
    beforeDate: {
      type: String,
      default: null
    },
    afterDate: {
      type: String,
      default: null
    },
    reachType: {
      type: Number,
      default: null
    },
    minDate: {
      type: Date,
      default: null
    },
    maxDate: {
      type: Date,
      default: null
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  emits: [
    'update:report-type',
    'update:report-name',
    'update:order',
    'update:line-item',
    'update:segment',
    'update:category',
    'update:categories',
    'update:before-date',
    'update:after-date',
    'update:reach-type',
  ],
  data () {
    return {
    }
  },
  computed: {
    ...mapState('amcBrandReports', ['campaignList', 'lineItemList', 'segmentList', 'categoriesList', 'minStartDay']),
    ...mapState('amcProfile', ['activeAmcProfile']),
    innerReportType: {
      get () {
        return this.reportType
      },
      set (val) {
        this.$emit('update:report-type', val)
      }
    },
    innerReportName: {
      get () {
        return this.reportName
      },
      set (val) {
        this.$emit('update:report-name', val)
      }
    },
    innerOrder: {
      get () {
        return this.order
      },
      set (val) {
        this.$emit('update:order', val)
      }
    },
    innerLineItem: {
      get () {
        return this.lineItem
      },
      set (val) {
        this.$emit('update:line-item', val)
      }
    },
    innerSegment: {
      get () {
        return this.segment
      },
      set (val) {
        this.$emit('update:segment', val)
      }
    },
    innerCategory: {
      get () {
        return this.category
      },
      set (val) {
        this.$emit('update:category', val)
      }
    },
    innerCategories: {
      get () {
        return this.categories
      },
      set (val) {
        this.$emit('update:categories', val)
      }
    },
    innerBeforeDate: {
      get () {
        return this.beforeDate
      },
      set (val) {
        this.$emit('update:before-date', val)
      }
    },
    innerAfterDate: {
      get () {
        return this.afterDate
      },
      set (val) {
        this.$emit('update:after-date', val)
      }
    },
    innerReachType: {
      get () {
        return this.reachType
      },
      set (val) {
        this.$emit('update:reach-type', val)
      }
    },
    optionReportType () {
      const reportTypeConditions = [7, 8, 9, 12]
      let reportType = Object.keys(AMC_REPORT_TYPE).filter(key => reportTypeConditions.includes(Number(key)) ).map(key => ({text: AMC_REPORT_TYPE[key], value: Number(key)}))
      if (!this.activeAmcProfile.hasOwnProperty('isPaidTable') || this.activeAmcProfile.isPaidTable === 0) {
        // 注文率リフト、リーチカバレッジはis_paid_table＝0の場合は選択できない
        reportType = reportType.map(type => {
          if (type.value === 8 || type.value === 12 ) {
            return type
          } else {
            return { ...type, $isDisabled: true }
          }
        })
      }
      return reportType
    },
    optionOrder () {
      return this.campaignList.map((item) => (
        {text: item, value: item}
      ))
    },
    optionLineItem () {
      return this.lineItemList.map((item) => (
        {text: item, value: item}
      ))
    },
    optionSegment () {
      return this.segmentList.map((item) => (
        {text: item, value: item}
      ))
    },
    optionCategory () {
      const category = [
        { text:'ブランド', value: 'brand'},
        { text:'出品者カテゴリー', value: 'seller_category'},
        { text:'出品者カテゴリー2', value: 'seller_category2'},
        { text:'出品者カテゴリー3', value: 'seller_category3'},
        { text:'出品者カテゴリー4', value: 'seller_category4'},
        { text:'出品者カテゴリー5', value: 'seller_category5'}
      ]
      return category
    },
    optionCategories () {
      if (this.innerCategory === null) return []
      return this.categoriesList[this.camelC(this.innerCategory)].map((item) => (
        {text: item, value: item}
      ))
    },
    optionReachType () {
      return [
        {text: 'viewable_impressions', value: 1},
        {text: 'impressions', value: 2},
        {text: '動画再生開始', value: 3},
        {text: '動画視聴完了', value: 4},
      ]
    },
    optionReachTypeNonVideo () {
      return [
        {text: 'viewable_impressions', value: 1},
        {text: 'impressions', value: 2},
      ]
    }
  },
  methods: {
    camelC (string) {
      return string.replace('_c', 'C')
    }
  }
}
</script>
